import { render } from "./RemovePatientConfirmationDialog.vue?vue&type=template&id=ca25f758&scoped=true"
import script from "./RemovePatientConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./RemovePatientConfirmationDialog.vue?vue&type=script&lang=js"

import "./RemovePatientConfirmationDialog.vue?vue&type=style&index=0&id=ca25f758&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca25f758"]])

export default __exports__